/* eslint-disable camelcase */
/* eslint-disable max-len */
// ==============================================
// ==================Import======================
// ==============================================

// ==================Style&IMG===================
import './style.scss';

// ==================react hook===================
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';

// ===================Librairie joyride================
import Joyride, { STATUS } from 'react-joyride';
import { CircularProgress } from '@mui/material';
import classNames from 'classnames';

// ===================Actions================
import { setOpenTour } from '../../actions/site';
import {
  fetchFilesDataPagination,
  launchDataPagination,
  saveFilesData,
  saveFilesGrid,
  saveLocationFile,
  setLoadingFiles,
  setMarkerFilesString,
  setPageValue,
  setValueDisplayLoading,
} from '../../actions/file';

// ==================Component===================
import MenuButton from '../MenuButton';
import FileGrid from './FileGrid';
import Modaldownload from './Modaldownload';
import ModalExportQuery from '../ModalExportQuery';
import ModalNoData from '../ModalNoData';
import Spinner2 from '../Spinner2';
import { setModalNoData } from '../../actions/multipleMetadata';
import { globalConfig } from '../../configuration/config';

function File() {
  // ==================HOOKS===================

  const dispatch = useDispatch();
  const loadingMap = useSelector((state) => state.site.map.loadingMap);
  const openTour = useSelector((state) => state.site.joyride.openTour);
  const loadingFiles = useSelector((state) => state.files.loadingFiles);
  // const slug = useParams();
  const { '*': slug } = useParams();
  const decoded = decodeURIComponent(slug || '');

  const filesData = useSelector((state) => state.files.dataFiles);
  const filesDataPagination = useSelector((state) => state.files.dataFilePagination);

  const listStation = useSelector((state) => state.dataAPI.stations.list.data);

  const location = useLocation();

  const locationFile = useSelector((state) => state.files.location);

  const page = useSelector((state) => state.files.page);
  const dataPagination = useSelector((state) => state.files.dataPagination);
  const markerFilesString = useSelector((state) => state.files.markerFilesString);
  const numberPerPage = useSelector((state) => state.files.numberPerPage);
  const filesGrid = useSelector((state) => state.files.filesGrid);
  const displayLoading = useSelector((state) => state.files.displayLoading);

  // ==================Defined steps for joyride lib===================

  const steps = [
    {
      target: '.multipleFilesDataGrid',
      content: <p><strong>Step 1: </strong>Select the files by clicking on the checkboxes</p>,
      disableBeacon: true,
    },
    {
      target: '.btn-download',
      content: <p><strong>Step 2: </strong>Download the stations metadata in different format</p>,
      disableBeacon: true,
    },
    {
      target: '.btn-export',
      content:
  <p><strong>Step 3: </strong>
    Export the query for the command line tool and API request format
  </p>,
      disableBeacon: true,
    },
  ];

  const display = classNames('files--loading--container', { 'files--loading--container--display': displayLoading });

  // ==============Function========================

  // function for construction of row file grid to inject data in lib
  function rowsOfFilesGrid() {
    const rowsFilesGrid = [];
    if (filesData.length !== 0) {
      for (let i = 0; i <= filesData.length - 1; i += 1) {
        const dataGridRow = {
          id: i,
          file_name: filesData[i].name,
          file_type: filesData[i].file_type.format,
          reference_date: filesData[i].reference_date,
          published_date: filesData[i].published_date,
          revision_date: filesData[i].revision_date,
          sampling_window: filesData[i].file_type.sampling_window,
          sampling_frequency: filesData[i].file_type.sampling_frequency,
          md5_check_sum: filesData[i].md5_checksum,
          file_size: filesData[i].file_size,
          data_center_acronyme: filesData[i].data_center.acronym,
          status: filesData[i].status,
        };
        rowsFilesGrid.push(dataGridRow);
      }
    }
    dispatch(saveFilesGrid(rowsFilesGrid));
    dispatch(setLoadingFiles(false));
  }

  // handler for launching joyrid tour of interface
  const handleJoyrideCallback = (data) => {
    const { status } = data;
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

    if (finishedStatuses.includes(status)) {
      dispatch(setOpenTour(false));
    }
  };

  useEffect(() => {
    if (filesData.length >= 5000) {
      const slugMarker = decoded.substring(7, decoded.indexOf('&'));
      const endQueries = decoded.substring(decoded.indexOf('&'), decoded.length);
      if (page === 2) {
        dispatch(setValueDisplayLoading(true));
      }
      if (decoded.includes('marker=') && listStation !== undefined && decoded.includes('&') === false && decoded.length < 16) {
        dispatch(fetchFilesDataPagination(page, `marker=${markerFilesString}`, numberPerPage, globalConfig.config.REACT_APP_NODE_URL, globalConfig.config.REACT_APP_GLASS_API));
      }
      else if (decoded.includes('marker=') && listStation !== undefined && decoded.includes('&') && slugMarker.length < 9) {
        dispatch(fetchFilesDataPagination(page, `marker=${markerFilesString}${endQueries}`, numberPerPage, globalConfig.config.REACT_APP_NODE_URL, globalConfig.config.REACT_APP_GLASS_API));
      }
      else {
        dispatch(fetchFilesDataPagination(page, decoded, numberPerPage, globalConfig.config.REACT_APP_NODE_URL, globalConfig.config.REACT_APP_GLASS_API));
      }
    }
  }, [filesData]);

  useEffect(() => {
    if (dataPagination) {
      dispatch(launchDataPagination(false));
      dispatch(setPageValue(page + 1));
      dispatch(saveFilesData([...filesData, ...filesDataPagination]));
    }
  }, [filesDataPagination]);

  useEffect(() => {
    if (locationFile.length === 0) {
      dispatch(saveLocationFile(location.pathname));
    }
    let slugMarker = decoded.substring(7, decoded.indexOf('&'));
    slugMarker = slugMarker.toUpperCase();
    const endQueries = decoded.substring(decoded.indexOf('&'), decoded.length);
    console.log('slugMarker', slugMarker, endQueries);
    // Case where the query contains marker=, without additional parameters and with a slug greater than or equal to 16, therefore with a station name of at least 9 characters
    if (decoded.includes('marker=') && listStation !== undefined && decoded.includes('&') === false && decoded.length >= 16) {
      dispatch(fetchFilesDataPagination(page, decoded, numberPerPage, globalConfig.config.REACT_APP_NODE_URL, globalConfig.config.REACT_APP_GLASS_API));
    }
    // Case where the query contains marker=, with additional parameters and with a station name less than 9 characters
    else if (decoded.includes('marker=') && listStation !== undefined && decoded.includes('&') && slugMarker.length < 9) {
      let queries = '';
      listStation.forEach((el) => {
        if (el.marker_long_name.startsWith(slugMarker)) {
          queries += `${el.marker_long_name},`;
        }
      });
      queries = queries.substring(
        0,
        queries.length - 1,
      );
      dispatch(setMarkerFilesString(queries));
      if (queries.length > 0) {
        dispatch(fetchFilesDataPagination(page, `marker=${queries}${endQueries}`, numberPerPage, globalConfig.config.REACT_APP_NODE_URL, globalConfig.config.REACT_APP_GLASS_API));
      }
      if (queries.length === 0) {
        dispatch(setModalNoData(true));
      }
    }
    // Case where the query contains marker=, with additional parameters and with a station name greater than or equal to 9 characters
    else if (decoded.includes('marker=') && listStation !== undefined && decoded.includes('&') && slugMarker.length >= 9) {
      dispatch(fetchFilesDataPagination(page, decoded, numberPerPage, globalConfig.config.REACT_APP_NODE_URL, globalConfig.config.REACT_APP_GLASS_API));
    }
    // Case where the query contains marker=, without additional parameters and with a slug less than 16 characters, therefore an incomplete station name
    else if (decoded.includes('marker=') && listStation !== undefined && decoded.includes('&') === false && decoded.length < 16) {
      let slugString = decoded.substring(7);
      slugString = slugString.toUpperCase();
      let queries = '';
      listStation.forEach((el) => {
        if (el.marker_long_name.startsWith(slugString)) {
          queries += `${el.marker_long_name},`;
        }
      });
      queries = queries.substring(
        0,
        queries.length - 1,
      );
      dispatch(setMarkerFilesString(queries));
      if (queries.length > 0) {
        dispatch(fetchFilesDataPagination(page, `marker=${queries}`, numberPerPage, globalConfig.config.REACT_APP_NODE_URL, globalConfig.config.REACT_APP_GLASS_API));
      }
      if (queries.length === 0) {
        dispatch(setModalNoData(true));
      }
    }
    // Case where the query does not contain marker=
    else if (decoded.includes('marker=') === false) {
      dispatch(fetchFilesDataPagination(page, decoded, numberPerPage, globalConfig.config.REACT_APP_NODE_URL, globalConfig.config.REACT_APP_GLASS_API));
    }
  }, [listStation]);

  useEffect(() => {
    if (locationFile.length !== 0 && locationFile !== location.pathname) {
      window.location.reload();
    }
  });

  // ============== UseEffect ========================
  useEffect(() => {
    rowsOfFilesGrid();
  }, [filesData]);

  useEffect(() => {
    console.log(slug, decoded);
  });

  return (
    <div>
      <Joyride
        run={openTour}
        steps={steps}
        callback={handleJoyrideCallback}
        continuous
        hideCloseButton
        scrollToFirstStep
        showProgress
        showSkipButton
        styles={{
          options: {
            zIndex: 10000,
            primaryColor: '#048b9a',
          },
        }}
      />
      {(loadingMap || loadingFiles) && (
        <>
          <Spinner2 />
          <ModalNoData />
        </>
      )}
      {(!loadingMap && !loadingFiles) && (
        <>
          <MenuButton />
          <div className={display}>
            <div className="files--loading--display"><CircularProgress color="success" size="1.2em" className="files--loading--loader" /> Files being loaded: {filesGrid.length} files loaded</div>
          </div>
          <div className="fileGrid">
            <FileGrid />
          </div>
          <div><Modaldownload /></div>
          <ModalExportQuery />
          <ModalNoData />
        </>
      )}
    </div>
  );
}

export default File;
